import { render, staticRenderFns } from "./MenuNotifications.vue?vue&type=template&id=586422d8"
import script from "./MenuNotifications.vue?vue&type=script&lang=js"
export * from "./MenuNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports